import IncapacitatedReportsView from '@src/main/modules/reports/incapacitated/ui/IncapacitatedReportsView';
import ContentCard from '@src/main/shared/ui/components/card/ContentCard';
import HeaderTitle from '@src/main/shared/ui/components/header/HeaderTitle';
import { useTranslation } from 'react-i18next';

const IncapacitatedReportsPage = () => {
  const { t } = useTranslation();

  return (
    <ContentCard>
      <HeaderTitle title={t('reports.menu.incapacitated')} />
      <IncapacitatedReportsView />
    </ContentCard>
  );
};

export default IncapacitatedReportsPage;
